import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';

const InvoicesModel = types
  .model('InvoicesModel', {
    amount: types.optional(types.string, ''),
    availableSourceOfFundCodes: types.array(types.string),
    callBackUrl: types.maybeNull(types.string),
    currency: types.optional(types.string, ''),
    deepLink: types.optional(types.string, ''),
    description: types.optional(types.string, ''),
    merchantName: types.optional(types.string, ''),
    qr: types.optional(types.string, ''),
    ref1: types.optional(types.string, ''),
    ref2: types.optional(types.string, ''),
    returnUri: types.maybeNull(types.string),
    sourceOfFundsCode: types.maybeNull(types.string),
    status: types.optional(types.string, ''),
    txId: types.optional(types.string, ''),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default InvoicesModel;
